import React, { useEffect, useState } from 'react';
import { accessToken, getProfile } from '../../api/auth';
import '../../css/Member.css';

export default function WithdrawalOne({ setText }: any) {
  const [userData, setUserData] = useState<any>([]);
  useEffect(() => {
    getProfile()
      .then((res) => {
        setUserData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [accessToken]);

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <>
      <div className="withdrawal_wrap">
        <h3>
          잠깐!
          <br />
          탈퇴 전 꼭 확인해 주세요
        </h3>
        <div className="txt_box">
          <p>
            <span>{userData.nickname}</span>님, <br />
            받을 수 있는 혜택이
            <br />
            아직 남아있어요!
          </p>
          <p>
            다른 어바웃피싱 회원들은
            <br />
            획득한 코인을 사용해
            <br />
            구매 시 <span>평균 1만원</span> 이상의
            <br />
            결제 할인 혜택을 받고 있어요!
          </p>
          <p>
            그래도 <br />
            탈퇴하시겠어요?
          </p>
        </div>
        <div className="btn_box">
          <button
            onClick={() => {
              setText('two');
            }}
          >
            다음으로
          </button>
        </div>
      </div>
    </>
  );
}
